/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import { BlackButton } from "../BlackButton";
import { moreButtonStyle, moreButtonWrapperStyle } from "./styles";

import type { Props } from "./props";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

// TODO: 多言語対応予定
export const ShowMoreButton: FcWithoutChildren<Props> = (props) => {
  const { isShown, onClickShowMore } = props;

  if (!isShown) return null;

  return (
    <div css={moreButtonWrapperStyle}>
      <BlackButton css={moreButtonStyle} onClick={onClickShowMore}>
        もっと見る
      </BlackButton>
    </div>
  );
};
